import type { OrgActiveAndOrRemovedUsers } from 'src/types';
import { baseFetch } from 'src/utils';

export const getAllActiveAndRemovedUsersAPI = async () => {
  const res = await baseFetch('/api/org/users/all-active-and-removed', {
    method: 'GET',
  });

  if (!res.ok) {
    throw new Error('Failed to fetch all active and removed users');
  }

  const data = await res.json();

  const users = data.users as OrgActiveAndOrRemovedUsers[];

  return users;
};
